import React from "react";
import {
  AddToCartWithQuantity as SharedAddToCartWithQuantity,
  AddToCartWithQuantityProps as SharedAddToCartWithQuantityProps,
} from "~/features/shopping/ui";
import Error from "../Error";

interface AddToCartWithQuantityProps extends SharedAddToCartWithQuantityProps {
  error?: string;
}

const AddToCartWithQuantity = ({
  error,
  ...rest
}: AddToCartWithQuantityProps) => (
  <>
    <SharedAddToCartWithQuantity {...rest}>
      Add to Cart
    </SharedAddToCartWithQuantity>
    {error && <Error>{error}</Error>}
  </>
);

export default AddToCartWithQuantity;
